import React, { Component } from 'react';
import './index.less';
import Style from './index.less';
import PropTypes from 'prop-types';

export default class LiveGuideDialog extends Component {

    static propTypes = {
        darkMode: PropTypes.bool,
    };

    static defaultProps = {
        darkMode: true,
    };

    constructor(props) {
        super(props);
    }

    render() {

        let textColor = this.props.darkMode ? '#FFF' : '#333333';
        let bubbleDark = (this.props.darkMode ? (' bubble-dark-liveGuide ' + Style['bubble-dark-liveGuide']) : '');

        return (
            <div className={'dialog-wrapper-liveGuide ' + Style['dialog-wrapper-liveGuide'] + ' bubble-liveGuide ' + Style['bubble-liveGuide'] + ' top-liveGuide ' + Style['top-liveGuide'] + bubbleDark} >
                {/* <div className={this.props.darkMode ? ('top-tip-dark-liveGuide ' + Style['top-tip-dark-liveGuide']) : ('top-tip-liveGuide ' + Style['top-tip-liveGuide'])} /> */}
                <button aria-label="Close" className={'modal-close-liveGuide ' + Style['modal-close-liveGuide']} onClick={this.props.handleCloseLiveGuideDialog}><span className={'modal-close-x-liveGuide ' + Style['modal-close-x-liveGuide']}></span></button>
                <div className={'modal-content-liveGuide ' + Style['modal-content-liveGuide']}>
                    <h1 style={{ color: textColor }}>欢迎使用远程演示</h1>
                    <p className={'modal-p-liveGuide ' + Style['modal-p-liveGuide'] + (this.props.darkMode ? (' dark-text-liveGuide ' + Style['dark-text-liveGuide']) : null)}>
                        手机电脑同步观看，语音讨论更加高效
                    </p>
                    {
                        this.props.darkMode ? null : <div className={'img-wrapper-liveGuide ' + Style['img-wrapper-liveGuide'] + ' icon-guide-2x-liveGuide ' + Style['icon-guide-2x-liveGuide']}></div>
                    }
                    <div>
                        <button className={'sm-button-liveGuide ' + Style['sm-button-liveGuide']} type="black" onClick={this.props.handleOpenDocLive}>邀请好友</button>
                    </div>
                </div>
            </div>
        );
    }
}